'use client';

import * as React from 'react';
import {
  publishedDateTypeAtom,
  showPublishDateAtom,
} from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

type PublishedDateProps = {
  publishAt: Date | string | null;
  updatedAt: Date | string;
  createdAt: Date | string;
  hasTitle: boolean;
};

export function PublishedDate({
  updatedAt,
  createdAt,
  publishAt,
  hasTitle,
}: PublishedDateProps) {
  const showPublishDate = useAtomValue(showPublishDateAtom);
  const publishedDateType = useAtomValue(publishedDateTypeAtom);
  const t = useTranslations('Blog.FeaturedPost');
  if (!showPublishDate) {
    return <></>;
  }
  return (
    <div className="post-published-date" data-author-has-title={hasTitle}>
      <p className="post-meta-label">{t('PublishedOn')}</p>
      <p className="post-published-date-value">
        {new Date(
          publishAt ||
            (publishedDateType === 'createdDate' ? createdAt : updatedAt),
        ).toLocaleDateString()}
      </p>
    </div>
  );
}
